<template>
  <a v-if="result" :href="result.href" class="header-shops">
    <svg class="header-shops__icon">
      <use xlink:href="#svg-diamond"></use>
    </svg>
    {{ result.name }}
  </a>
</template>

<script lang="ts" setup>
const props = defineProps<{
  result: {
    name: string;
    href: string;
  };
}>();
</script>

<style lang="scss" scoped>
.header-shops {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 125%;
  margin-right: 24px;
  transition: 0.2s linear color;
  &:hover {
    color: var(--color-link-hover);
    .header-shops__icon {
      fill: currentColor;
    }
  }
  &__icon {
    width: 18px;
    height: 18px;
    margin-right: 4px;
    fill: #fff;
    flex-shrink: 0;
  }
}
</style>
